import r from "./td-longtail-vue-components280.js";
/* empty css                              */
import i from "./td-longtail-vue-components98.js";
var n = function() {
  var a = this, t = a._self._c, e = a._self._setupProxy;
  return t("div", { staticClass: "variant-selector" }, [a.displayName !== "Preis" && !a.hideName ? t("span", { staticClass: "variant-selector__label" }, [a._v(" " + a._s(a.displayName) + ": " + a._s(e.activeVariantName) + " ")]) : a._e(), e.isColorSelector ? t(e.VariantSelectorColor, { staticClass: "variant-selector__entry", attrs: { variants: a.variants, "is-accessible": a.isAccessible, value: e.activeVariantIndex }, on: { "select-variant": (s) => a.$emit("select-variant", s) } }) : t(e.VariantSelectorBasic, { staticClass: "variant-selector__entry", attrs: { variants: a.variants, "is-accessible": a.isAccessible, "display-name": a.displayName }, on: { "select-variant": (s) => a.$emit("select-variant", s) } })], 1);
}, c = [], l = /* @__PURE__ */ i(
  r,
  n,
  c,
  !1,
  null,
  "79acc485"
);
const p = l.exports;
export {
  p as default
};
